import { loadIntroJS } from '../../../services/scripts.service';
import { NavigateFunction } from 'react-router-dom';

export const getTeacherTourSteps = (self: any) => [
  {
    element: document.querySelector('.teacher-tour-add-student-button'),
    title: 'Add Students',
    intro: `<div class="teacher-tour-content">
              <div class="teacher-tour-text">Type or paste names, or import from Clever/Google.</div>
              <div class="teacher-tour-text">You can always add more later.</div>
            </div>`,
    position: 'bottom',
    route: '/classroom/students',
  },
  {
    element: document.querySelector('.teacher-tour-print-passwords-button'),
    title: 'Print Passwords',
    intro: `<div class="teacher-tour-content"><div class="teacher-tour-text">When you’re ready, print student logins. These are the usernames and passwords your students will use.</div></div>`,
    position: 'bottom',
    route: '/classroom/students',
  },
  {
    element: document.querySelector('.teacher-tour-pre-session-flyers-button'),
    title: 'Pre-Session Flyer',
    intro: `<div class="teacher-tour-content">
              <div class="teacher-tour-text">Send flyers home <strong>7 days before</strong> your start date. This is required for the publishing program.</div>
            </div>`,
    position: 'bottom',
    route: '/classroom/students',
  },
  {
    element: document.querySelector('.teacher-tour-group-code-container'),
    title: 'Group Code',
    intro: `<div class="teacher-tour-content"><div class="teacher-tour-text">You can also share this Group Code with a parent along with their child's username. This is a backup option if flyers are not used or get lost.</div></div>`,
    position: 'bottom',
    route: '/classroom/students',
  },
  {
    element: self.getDynamicElementElement('teacher-tour-main-navigation-dashboard', 'Dashboard'),
    title: 'Dashboard',
    intro: `<div class="teacher-tour-content">
              <div class="teacher-tour-text">The Dashboard button takes you to your main page, where you’ll see class progress and next steps.</div>
            </div>`,
    position: 'bottom',
    // Disable interaction is false to allow clicking the Dashboard link
    // disableInteraction: false,
    route: '/classroom/students',
  },
  {
    element: document.querySelector('.teacher-tour-dashboard-project-summary-container'),
    title: 'Project Summary',
    intro: `<div class="teacher-tour-content"><div class="teacher-tour-text">Set your class start date here. This section also shows your overall progress at a glance.</div></div>`,
    position: 'bottom',
    route: '/classroom/dashboard',
  },
  {
    element: document.querySelector('.teacher-tour-dashboard-next-step-container'),
    title: 'Next Step Card',
    intro: `<div class="teacher-tour-content"><div class="teacher-tour-text">This card highlights the most important thing to do next. It keeps you on track, step by step.</div></div>`,
    position: 'bottom',
    route: '/classroom/dashboard',
  },
  {
    element: document.querySelector('.teacher-tour-dashboard-tour-link-button'),
    title: 'Take a Quick Tour link',
    intro: `<div class="teacher-tour-content"><div class="teacher-tour-text">If you want to have this tour again, it is available from here.</div></div>`,
    position: 'bottom',
    route: '/classroom/dashboard',
  },
  {
    element: document.querySelector('.teacher-tour-dashboard-timeline-container'),
    title: 'Timeline',
    intro: `<div class="teacher-tour-content"><div class="teacher-tour-text">The timeline shows your program from setup to celebration. It helps you track progress and know what is coming.</div></div>`,
    position: 'top',
    route: '/classroom/dashboard',
  },
  {
    element: self.getDynamicElementElement('teacher-tour-main-navigation-my-library'),
    title: 'My Library',
    intro: `<div class="teacher-tour-content"><div class="teacher-tour-text">The Library is where your students’ books will appear. From here you can share e-books digitally and send books to be printed.</div></div>`,
    position: 'bottom',
    route: '/classroom/dashboard',
  },
];

export class TeacherTour {
  private tourInstance: any = null;
  private currentStep: number = 1;
  private navigateTo: NavigateFunction | null = null;
  private onFinish: (isSkip?: boolean) => void = () => {};
  private lockedMode: boolean = false;

  // Function to check if mobile menu needs to be opened
  private ensureMobileMenuIsOpen = () => {
    const isMobile = window.innerWidth < 640; // sm breakpoint
    if (isMobile) {
      const mobileMenuButton = document.querySelector('#mobile-teacher-navigation-menu-button');

      // If mobile menu is not visible, click the toggle button
      if (mobileMenuButton && !mobileMenuButton.classList.contains('opened')) {
        (mobileMenuButton as HTMLElement).click();
      }
    }
  };

  // Function to hide/show Next button based on step
  private toggleNextButton = (currentStep: any) => {
    console.log(currentStep);
    const nextButton = document.querySelector('.introjs-nextbutton') as any;
    if (nextButton) {
      if (currentStep === 4) {
        // Dashboard step (step 5 in the new sequence)
        nextButton.style.display = 'none';
      } else {
        nextButton.style.display = 'inline-block';
      }
    }
  };

  private getNewItemByClassName = (className: string): Promise<Element | null> => {
    return new Promise((resolve) => {
      const startTime = Date.now();
      const timeout = 30000; // 30 seconds

      const checkForElement = () => {
        const element = document.querySelector(`.${className}`);

        if (element) {
          resolve(element);
        } else if (Date.now() - startTime > timeout) {
          resolve(null);
        } else {
          setTimeout(checkForElement, 100); // Check every 100ms
        }
      };

      checkForElement();
    });
  };

  // Function to handle Dashboard click and advance tour
  private handleDashboardClick = async () => {
    // Don't prevent default - let the link work naturally
    console.log('Dashboard clicked during tour - allowing natural navigation');

    // Exit the tour since user is navigating to Dashboard
    this.nextStep();
  };

  // Function to get the correct Dashboard element based on screen size
  getDynamicElementElement = (className: string, title?: string) => {
    const isMobile = window.innerWidth < 640;
    if (isMobile) {
      // Ensure mobile menu is open before trying to find the element
      // !hideOpenMenu && this.ensureMobileMenuIsOpen();
      // Wait a bit for the menu to render, then find the element
      setTimeout(() => {
        return document.querySelector(`.mobile-${className}`);
      }, 250);
      return document.querySelector(`.mobile-${className}`);
    } else {
      // For desktop, find the Dashboard link in the regular navigation
      const desktopLinks = document.querySelectorAll('.hidden.sm\\:flex a');
      for (const link of desktopLinks) {
        if (title && link.textContent?.trim() === title) {
          return link;
        }
      }
    }
    return document.querySelector(`.${className}`);
  };

  public async start(
    navigateTo: NavigateFunction,
    onFinish: (isSkip?: boolean) => void,
    openStep?: number,
    lockedMode?: boolean,
  ): Promise<void> {
    const introJs = await loadIntroJS();
    this.navigateTo = navigateTo;
    this.onFinish = onFinish;
    this.lockedMode = !!lockedMode;
    this.exit();
    this.tourInstance = introJs.tour();
    this.initTour(openStep);
  }

  public async refreshTour(): Promise<void> {
    this.tourInstance
      ?.setOptions({
        steps: getTeacherTourSteps(this),
        showProgress: false,
        showBullets: true,
        exitOnOverlayClick: false,
        exitOnEsc: false,
        showStepNumbers: false,
        showPrevButton: !this.lockedMode,
        showSkipButton: !this.lockedMode,
        nextLabel: this.lockedMode ? 'Continue' : undefined,
        disableInteraction: true,
        scrollToElement: true,
        tooltipClass: 'teacher-tour-tooltip',
      })
      ?.refresh(true);
    console.log(this.tourInstance?.steps);
  }

  public initTour(openStep?: number): void {
    this.tourInstance
      .setOptions({
        steps: getTeacherTourSteps(this),
        showProgress: false,
        showBullets: true,
        exitOnOverlayClick: false,
        exitOnEsc: false,
        showStepNumbers: false,
        showPrevButton: !this.lockedMode,
        showSkipButton: !this.lockedMode,
        nextLabel: this.lockedMode ? 'Continue' : undefined,
        disableInteraction: true,
        scrollToElement: true,
        tooltipClass: 'teacher-tour-tooltip',
      })
      .onAfterChange(() => {
        // Ensure overlay always blocks clicks except for specific allowed elements
        setTimeout(() => {
          const overlay = document.querySelector('.introjs-overlay') as HTMLElement;
          if (overlay) {
            overlay.style.pointerEvents = 'auto';
            overlay.style.cursor = 'not-allowed';
          }

          const helperLayer = document.querySelector('.introjs-helperLayer') as HTMLElement;
          if (helperLayer) {
            helperLayer.style.pointerEvents = 'auto';
          }

          // Prevent clicks on body during tour
          document.body.style.pointerEvents = 'none';

          // Re-enable pointer events on tour elements
          const tourTooltip = document.querySelector('.introjs-tooltip') as HTMLElement;
          if (tourTooltip) {
            tourTooltip.style.pointerEvents = 'auto';
          }

          const nextButton = document.querySelector('.introjs-nextbutton') as HTMLElement;
          if (nextButton) {
            nextButton.style.pointerEvents = 'auto';
          }

          const prevButton = document.querySelector('.introjs-prevbutton') as HTMLElement;
          if (prevButton) {
            prevButton.style.pointerEvents = 'auto';
          }

          const skipButton = document.querySelector('.introjs-skipbutton') as HTMLElement;
          if (skipButton) {
            skipButton.style.pointerEvents = 'auto';
          }
        }, 100);
      })
      .onComplete(() => {
        // Restore body pointer events when tour completes successfully (Done button)
        document.body.style.pointerEvents = 'auto';
        console.log('Tour completed successfully via Done button');
        this.onFinish(false);
      })
      .onExit(() => {
        // Restore body pointer events when tour exits early (Skip button, ESC, overlay click)
        document.body.style.pointerEvents = 'auto';
        console.log('Tour exited early via Skip button or ESC');
        this.onFinish(true);
      })
      .onBeforeChange(async (_targetElement: any, currentStep: number, direction: string) => {
        return new Promise<boolean>((resolve) => {
          this.currentStep = currentStep;
          console.log('Step info:', {
            currentStep,
            direction,
            targetStep: direction === 'forward' ? currentStep + 1 : currentStep - 1,
          });

          const activeStep = this.tourInstance?._steps.find((step: any) => step.step === this.currentStep + 1);

          if (activeStep && activeStep.route) {
            const currentPath = window.location.pathname;
            if (currentPath !== activeStep.route) {
              console.log(`Navigating to route: ${activeStep.route}`);
              this.navigateTo && this.navigateTo(activeStep.route);
            }
          }

          // Hide Next button on Dashboard step
          // setTimeout(() => this.toggleNextButton(this.currentStep));

          // Enable Dashboard clicking on step 4
          if (this.currentStep === 4) {
            // setTimeout(() => {
            //   const dashboardElement = this.getDynamicElementElement(
            //     'teacher-tour-main-navigation-dashboard',
            //     'Dashboard',
            //   );
            //   if (dashboardElement) {
            //     // Force remove all intro.js blocking styles only from the Dashboard element
            //     (dashboardElement as HTMLElement).style.pointerEvents = 'auto';
            //     (dashboardElement as HTMLElement).style.zIndex = '99999';
            //     (dashboardElement as HTMLElement).style.position = 'relative';
            //
            //     // Add click event listener
            //     dashboardElement.addEventListener('click', this.handleDashboardClick);
            //
            //     console.log('Dashboard element made clickable:', dashboardElement);
            //   }
            // }, 200);
          } else {
            // Remove event listener from previous step and restore overlay blocking
            const dashboardElement = this.getDynamicElementElement(
              'teacher-tour-main-navigation-dashboard',
              'Dashboard',
            );
            if (dashboardElement) {
              dashboardElement.removeEventListener('click', this.handleDashboardClick);
            }

            // Restore overlay blocking for other steps
            const overlay = document.querySelector('.introjs-overlay') as HTMLElement;
            if (overlay) {
              overlay.style.pointerEvents = 'auto';
            }

            const helperLayer = document.querySelector('.introjs-helperLayer') as HTMLElement;
            if (helperLayer) {
              helperLayer.style.pointerEvents = 'auto';
            }
          }

          if (currentStep === 0) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }

          // Handle forward navigation to Dashboard step (step 4)
          if (direction === 'forward' && [4, 9].includes(currentStep)) {
            console.log('Moving to Dashboard step - opening mobile menu');
            // window.scrollTo({ top: 0, behavior: 'smooth' });
            this.ensureMobileMenuIsOpen();
            // Give extra time for mobile menu animation
            setTimeout(() => {
              resolve(true);
            }, 800);
          }
          // Handle backward navigation from Dashboard step (step 4) - close mobile menu if needed
          else if (direction === 'backward' && [5, 10].includes(currentStep)) {
            console.log('Moving back from Dashboard step');
            const isMobile = window.innerWidth < 640;
            if (isMobile) {
              const mobileMenuButton = document.querySelector('#mobile-teacher-navigation-menu-button');
              // Close mobile menu if it's open
              if (mobileMenuButton && mobileMenuButton.classList.contains('opened')) {
                (mobileMenuButton as HTMLElement).click();
              }
              setTimeout(() => {
                resolve(true);
              }, 500);
            } else {
              setTimeout(() => resolve(true), 500);
            }
          } else {
            setTimeout(() => resolve(true), 1000);
          }
        });
      })
      .start();

    // If openStep is provided, go to that specific step after tour starts
    if (openStep !== undefined && openStep >= 0) {
      setTimeout(() => {
        this.tourInstance.goToStep(openStep + 1); // IntroJS steps are 1-indexed
      }, 100);
    }
  }

  public exit(): void {
    if (this.tourInstance) {
      this.tourInstance.exit();
      this.tourInstance = null;
    }
    // Restore body pointer events when tour exits
    document.body.style.pointerEvents = 'auto';
  }

  public nextStep(): void {
    if (this.tourInstance) {
      this.tourInstance.nextStep();
    }
  }

  public previousStep(): void {
    if (this.tourInstance) {
      this.tourInstance.previousStep();
    }
  }
}

// Export singleton instance
export const teacherTour = new TeacherTour();
